"use strict";
exports.__esModule = true;
exports.AllAvailableNonSaleColors = exports.AllAvailableSaleColors = exports.AllNonSaleColors = exports.AllSaleColors = exports.AllAvailableColorsOnly = exports.AllAvailableColors = exports.AllColors = void 0;
var Constants_1 = require("./../../constant/Constants");
var First_1 = require("./First");
var AllColors = function (product, template, selectVariant, fallback) {
    var colorIndex = template.getOptionIndex(product, Constants_1.COLOR_OPTIONS);
    if (colorIndex === -1)
        return (fallback || First_1.FirstAvailableVariant)(product, template);
    var doneColors = [];
    return product.variants.filter(function (v) {
        var color = v.options[colorIndex];
        if (doneColors.indexOf(color) !== -1)
            return false;
        if (selectVariant && !selectVariant(v))
            return false;
        doneColors.push(color);
        return true;
    });
};
exports.AllColors = AllColors;
var AllAvailableColors = function (product, template) {
    return exports.AllColors(product, template, function (v) { return template.isVariantAvailable(v); });
};
exports.AllAvailableColors = AllAvailableColors;
var AllAvailableColorsOnly = function (product, template) {
    return exports.AllColors(product, template, function (v) { return template.isVariantAvailable(v); }, First_1.FirstAvailableVariantOnly);
};
exports.AllAvailableColorsOnly = AllAvailableColorsOnly;
var AllSaleColors = function (product, template) {
    return exports.AllColors(product, template, function (v) { return template.isVariantOnSale(v); });
};
exports.AllSaleColors = AllSaleColors;
var AllNonSaleColors = function (product, template) {
    return exports.AllColors(product, template, function (v) { return !template.isVariantOnSale(v); });
};
exports.AllNonSaleColors = AllNonSaleColors;
var AllAvailableSaleColors = function (product, template) {
    return exports.AllColors(product, template, function (v) { return template.isVariantAvailable(v) && template.isVariantOnSale(v); });
};
exports.AllAvailableSaleColors = AllAvailableSaleColors;
var AllAvailableNonSaleColors = function (product, template) {
    return exports.AllColors(product, template, function (v) { return template.isVariantAvailable(v) && !template.isVariantOnSale(v); });
};
exports.AllAvailableNonSaleColors = AllAvailableNonSaleColors;
//# sourceMappingURL=Color.js.map